module.exports = __webpack_public_path__ + "assets/hammerjs.f203effc.svg";